import { type DynamicForms } from "@common/controls/Form/DynamicForm/types";

export const getConsentFields = (fields: DynamicForms.Field[]): DynamicForms.Field[] => {
  return fields.filter((x) => x.formControlKey !== "PlainText");
};

export const getConsentFieldNames = (fields: DynamicForms.Field[]): string[] => {
  return getConsentFields(fields).map((x) => x.name);
};
